var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavicon18(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M5.15226 4.64605C5.36767 4.50245 5.26601 4.16669 5.00712 4.16669H2.50001C2.03977 4.16669 1.66667 4.53979 1.66667 5.00002V11.2632C1.66667 11.5753 1.75409 11.8766 1.91347 12.136C1.9362 12.173 1.98698 12.1783 2.01965 12.1497L3.36611 10.9715C4.56215 9.92502 6.37586 10.0286 7.4449 11.2046L9.69675 13.6816C10.5469 14.6168 10.698 15.9932 10.0709 17.0906C9.78466 17.5916 10.0526 18.249 10.6044 18.0802C10.732 18.0411 10.8562 17.9863 10.9742 17.9155L14.6485 15.7109C15.0655 15.4607 15.1805 14.908 14.898 14.5122L10.5091 8.36344C10.4054 8.2184 10.221 8.15532 10.0503 8.20655L7.97921 8.82785C6.95147 9.13619 5.83744 8.85535 5.07872 8.0966L4.83475 7.85263C3.90513 6.92301 4.05838 5.37531 5.15226 4.64605Z",
    fill: "url(#paint0_linear_19161_3907)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0762 4.99993H16.6668C17.1271 4.99993 17.5002 5.37303 17.5002 5.83326V11.6666C17.5002 12.1268 17.1271 12.4999 16.6668 12.4999H15.0002L11.5266 7.63687C11.1121 7.05662 10.3744 6.80433 9.69142 7.00922L7.62037 7.63055C7.03309 7.80673 6.3965 7.64624 5.96294 7.21268L5.71898 6.9687C5.34713 6.59686 5.40843 5.97778 5.84598 5.68608L10.3468 2.68549C10.896 2.31942 11.6093 2.31183 12.1662 2.66614L15.6288 4.86964C15.7625 4.95474 15.9178 4.99993 16.0762 4.99993ZM4.18924 11.9122L2.84277 13.0904C2.44993 13.4341 2.46621 14.0502 2.87668 14.3728L7.16064 17.7387C7.5607 18.0531 8.1466 17.9386 8.399 17.4969L8.98559 16.4704C9.34392 15.8433 9.25759 15.0568 8.77175 14.5224L6.51998 12.0454C5.90909 11.3734 4.87269 11.3142 4.18924 11.9122Z",
    fill: "#7A67FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19161_3907",
    x1: 1.66667,
    y1: 11.1599,
    x2: 15.0532,
    y2: 11.1599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C082FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7967FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavicon18);
export default __webpack_public_path__ + "static/media/navicon18.ea6ff0e7b964760dfdd8a7799ed9a21c.svg";
export { ForwardRef as ReactComponent };